<template>
  <div style="width: 100%" v-if="data && data.length">
    <h3>{{ type }}</h3>
    <table :style="{ ...borderStyle, width: '100%' }">
      <tr>
        <th v-for="col in columns" :key="col.prop" :style="borderStyle">
          {{ col.label }}
        </th>
      </tr>
      <tr v-for="(d, index) in data" :key="index">
        <td v-for="col in columns" :key="col.prop" :style="borderStyle">
          {{ formatter(d[col.prop]) }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    type: String,
    columns: Array,
    data: Array
  },
  data() {
    return {
      borderStyle: {
        border: "1px solid black"
      }
    };
  },
  methods: {
    formatter(cellValue) {
      return cellValue === undefined ? "-" : cellValue;
    }
  }
};
</script>

<style scoped></style>
